<template>
  <div id="app">
    <canvas id="reveal-effect"></canvas>
    <header>
      
          <div class="company-main-title"> ONE运动.中国</div>
      
        <nav class="corporate-switch-fragment">
            <!-- <div class="radio-inputs">
              <label class="radio" for="home">
                <input id="home" value="home" name="radio" type="radio" v-model="selectedValue"/>
                <span class="name">首页</span>
              </label>
              <label class="radio"  for="login">
                <input id="login" value="login" name="radio" type="radio"  v-model="selectedValue"/>
                <span class="name">登录/注册</span>
              </label>
              <label class="radio"  for="about">
                <input id="about" value="about" name="radio" type="radio"  v-model="selectedValue"/>
                <span class="name">关于我们</span>
              </label>
            </div> -->
             <ul>
                <li @click="scrollToElement('scrollContent')">
                  <a>关于我们</a>
                </li>
                <li >
                  <a href="https://www.jianghutiyu.cn/admin/#/login">登录/注册</a>
                </li>
            </ul>
        </nav>
    </header>
    <dashboard></dashboard>
    <about id="scrollContent"></about>
       <!-- 页脚 -->
    <footer>
        <p>&copy; 2025 ONE运动 版权所有</p>
    </footer>
     <!-- <router-view v-if="hasLoad"/> -->
  </div>
</template>

<script>

import { init } from './animition.js'
import about from './views/about/index.vue'
import dashboard from './views/dashboard/index.vue'
export default {
  name: 'App',
  components: {
    dashboard,
    about
  },
  data() {
    return {
      // selectedValue: 'home',
      hasLoad: false
    }
  },
  watch: {
  
  },
  methods: {
    scrollToElement(elementId) {
      this.$nextTick(() => {
        const element = document.getElementById(elementId);
            element.scrollIntoView({
              behavior: 'smooth', // 平滑滚动
              block: 'start'      // 对齐方式：顶部对齐
            });
       
      })

    }
  },
  mounted() {
    // setTimeout(() => {
    //      this.selectedValue = this.$route.name
    // }, 2000);
    init(() => { 
      console.log('999')
      this.hasLoad = true
    });
  },
}
</script>

<style>
body{
  height: 100vh;
  background: #f2f3f5;
  margin:0;
  padding:0;
}
#app{ 
   height: 100%;
   display: flex;
   flex-direction: column;
   align-items: center;
}
  #reveal-effect {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    z-index: 10;
    /* transition: all 5s; */
  }
  body.loaded #reveal-effect {
    opacity: 1;
  }

  body.revealed #reveal-effect {
    display: none;
  }
  .loaded .slider,.loaded .content,.loaded footer{
      display: block;
  }
  /* 导航栏样式 */
  header {
      width: 100%;
      padding: 0px 30px;
      z-index: 10;
      left:0%;
      top: 0px;
      box-sizing: border-box;
      right:0%;
      background: #FFF;
      /* position: fixed; */
      display: none;
       position: relative;
      /* width: 90%; */
  }
  .loaded header{
      display: flex;
      justify-content: center;
       justify-content:space-between
  }
  nav {
      width: 220px;
      align-items: center;
      background-color: #FFF;
      padding: 2px;
      border-radius: 10px;
   
  }

  nav ul {
      list-style-type: none;
      margin: 0;
      padding: 0;
      display: flex;
      height: 47px;
      position: relative;
  }
  nav ul:after {
      content: '';
      display: block;
      width: 1px;
      background: #333;
      height: 60%;
      position: absolute;
      top:20%;
      left:50%
  }
  nav ul li {
      /* margin-right: 20px; */
      height: 100%;
      width: 50%;
      text-align: center;
      line-height: 50px;
      cursor: pointer;
  }

  nav ul li a {
      text-decoration: none;
      transition: color 0.3s ease;
      font-size: 18px;
       color: #333;
      font-weight: bold;
  }
  /* .company-name{
   
  } */
  /* .company-name:after{
      content: '';
      display: block;
      background: #dedede;
      position: absolute;
      left:20px;
      top: 60px;
      right:20px;
      height: 1px;
  } */
  .company-main-title{
    font-size: 28px;
    font-weight: bold;
    line-height: 50px;
    color:rgb(22, 72, 178);
  }
  .company-sub-title{
    font-size: 14px;
    color: #999

  }
  nav ul li a:hover {
    color:rgb(22, 72, 178);
  }
  nav ul .active-home{
      background-color: rgb(22, 72, 178);
      border-radius: 10px;
  }
  nav ul .active-home a{
      color:#FFF;
  }
  footer {
    background-color: #1e272e;
    color: white;
    text-align: center;
    padding: 20px 0;
    width: 100%;
    margin-top:20px;
    display: none;
    box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.1);
}
</style>
